import { Box, Card, Checkbox, Chip, Dialog, FormControl, InputLabel, MenuItem, Button as MUIButton, Select, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
  Button
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddressField from 'src/pages/admin/components/AddressField';
import CreateTradingToken from './Create';
import EditTradingToken from './Edit';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import XTextInput from 'src/pages/admin/components/XTextInput';
import { chains } from 'src/assets/data';
import AuditLogDialog from 'src/pages/admin/components/AuditLog/AuditLogDialog';
import { Iconify } from 'src/components/iconify/iconify';


const ListFilter = (props: any) => {
  const { filterValues } = useListController();

  return (
    <Filter {...(props || {})}>
      {/* <FilterGroup alwaysOn spacing={0} p={0}>
        <FilterGroup>
          <TextInput source="address" label="module.trandingToken.address" />
          <SelectInput
              source="chainId"
              helperText={<span style={{ color: 'red' }}></span>}
              choices={[
                  { id: 501424, name: 'SOLANA' },
                  { id: 1, name: 'ETH' }
              ]}
          />
        </FilterGroup>
      </FilterGroup> */}
    </Filter>
  );
};

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();
  const [auditLogOpen, setAuditLogOpen] = useState(false);
  const [auditTitle, setAuditTitle] = useState('Audit Logs');
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  return (
    <PermissionGuard resource="tranding-tokens" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.trandingToken')}
          links={[
            { name: translate('resource.configs'), href: '#' },
            { name: translate('resource.trandingToken'), href: `/${Resources.trandingToken}` },
            { name: translate('resource.list') },
          ]}
          action={
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretch', sm: 'center' }}
              spacing={2}
              mb={1}
            >
              <PermissionGuard resource="tranding-tokens" action="create" fallback={<></>}>
                <CreateButton
                  variant="contained"
                  size="medium"
                  onClick={(e) => {
                    e.preventDefault();
                    setPopup(<CreateTradingToken onClose={() => setPopup(undefined)} />);
                  }}
                />
              </PermissionGuard>
              <PermissionGuard resource="audit-logs" action="read" fallback={<></>}>
                <Button
                  variant="contained"
                  size="medium"
                  color="secondary"
                  onClick={() => {
                    setSelectedRecord({});
                    setAuditTitle(`${translate('resource.auditLogs')} - ${translate('resource.trandingToken')}`);
                    setAuditLogOpen(true);
                  }}
                  label={translate('resource.auditLogs')}
                >
                  <Iconify icon="ph:note" />
                </Button>
              </PermissionGuard>
            </Stack>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            filters={<ListFilter />}
            perPage={10}
            exporter={false}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="tranding-tokens" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField source="symbol" label="module.trandingToken.symbol" sortable={false} />
                {/* <TextField source="name" label="module.trandingToken.name" sortable={false}/> */}
                {/* <TextField source="address" label="module.trandingToken.address" /> */}
                <FunctionField
                  label="module.trandingToken.address"
                  render={(record: any) => <AddressField address={record.address} />}
                  sortable={false}
                />

                <SelectField
                  source="chainId"
                  choices={chains}
                  label="module.trandingToken.chain"
                  sortable={false}
                />
                <FunctionField
                  label="module.trandingToken.enable"
                  render={(record) => (
                    <Chip
                      label={record.enable ? 'True' : 'False'}
                      color={record.enable ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <TextField source="order" label="module.trandingToken.order" sortable={false} />
                <TextField source="start" label="module.trandingToken.start" sortable={false} />
                <TextField source="end" label="module.trandingToken.end" sortable={false} />

                <FunctionField
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      <PermissionGuard resource="tranding-tokens" action="update" fallback={<></>}>
                        <EditButton
                          onClick={(e) => {
                            e.preventDefault();
                            setPopup(
                              <EditTradingToken
                                id={record.id}
                                onClose={() => setPopup(undefined)}
                              />
                            );
                          }}
                        />
                      </PermissionGuard>
                      <PermissionGuard resource="tranding-tokens" action="delete" fallback={<></>}>
                        <DeleteButton mutationMode="pessimistic" />
                      </PermissionGuard>
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="sm" fullWidth>
          {popup}
        </Dialog>
        <AuditLogDialog
          open={auditLogOpen}
          onClose={() => setAuditLogOpen(false)}
          recordId={selectedRecord?.id}
          resource={Resources.trandingToken}
          title={auditTitle}
        />
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
